import {TasksViewAppSettings} from "../../../../core/@types"
import {SystemStatusGroup} from "../../../../../../gd/const/system-status"

export default function table_settingConverter_V2ToV3(appSettingsConfig: TasksViewAppSettings) {
    // update systemStatusFilter:
    // In V2, the default was SystemStatusGroup.OPEN, whereas in V3 it is SystemStatusGroup.ALL.
    // To preserve the original behavior, if systemStatusFilter is undefined, set it to SystemStatusGroup.OPEN.
    // This ensures migration maintains the V2 default when not explicitly set.
    if (!appSettingsConfig.systemStatusFilter) {
        appSettingsConfig.systemStatusFilter = SystemStatusGroup.OPEN
    }
}